// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fu-a";
export var fulfillmentFormRail = "_fu-9";
export var headerTitleRow = "_fu-c";
export var orderDetailsWrapper = "_fu-7";
export var orderLinkTrigger = "_fu-2";
export var paymentInformationGrid = "_fu-h";
export var paymentSummaryColumn = "_fu-i";
export var shipmentContainer = "_fu-b";
export var shipmentDetailsMainPane = "_fu-8";
export var shipmentNavigationCard = "_fu-5";
export var shipmentNavigationRail = "_fu-3";
export var shipmentNavigationRailHeader = "_fu-4";
export var shipmentSummaryFact = "_fu-e";
export var shipmentSummaryGrid = "_fu-d";
export var shipmentSummaryMetadataRow = "_fu-f";
export var shipmentSummaryTags = "_fu-g";
export var shipmentWorkspace = "_fu-0";
export var shipmentWorkspaceContent = "_fu-6";
export var shipmentWorkspaceHeader = "_fu-1";